import React, { useEffect, useState } from "react";
import "./DoctorVisit.css";
import Accordion from "react-bootstrap/Accordion";
import {
  baby_images,
  Redcross,
  right_tick,
  Timer,
  Vaccination_img,
} from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { doctorVisitListApi } from "services/doctorVisit";
import { dateFormatWithTime } from "utils/dateFormat";
import TypographyLimit from "components/TypographyLimit";
import moment from "moment";

const DoctorVisit = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [visitList, setVisitList] = useState([]);
  const [selectedVisit, setSelectedVisit] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await doctorVisitListApi({ childId: _child, limit: 5000 });
      if (status === 200) {
        setVisitList(data?.data);
        if( data?.data?.length) {
          setSelectedVisit(data?.data?.[0]);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <>
      <div className="doctor_visit_parent">
        <div className="doctor_visit_wraped">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center">
              <div className="doctor_visit_lft w-75">
                <Accordion >
                  {
                    visitList?.map(visit => {
                      return <Accordion.Item eventKey={visit?._id} onClick={() => setSelectedVisit(visit)}>
                        <Accordion.Header>
                          <div className="doctor_visit_accordian_parent">
                            <div className="doctor_visit_accordian_wraper">
                              <div className="doctor_visit_accordian_lft">
                                <div className="timer_img">
                                  {
                                    visit?.status === "ATTENDED"
                                      ?
                                      <img src={right_tick} />
                                      :
                                      (visit?.status === "UPCOMING" && moment().isAfter(visit?.dateTime))
                                        ?
                                        <img src={Redcross} />
                                        :
                                        <img src={Timer} />
                                  }
                                </div>
                              </div>

                              <div className="doctor_visit_accordian_rgt">
                                <ul>
                                  <li>
                                    <p className="name">{visit?.doctorName}</p>
                                  </li>
                                  <li>
                                    <span className="date">{dateFormatWithTime(visit?.createdAt)}</span>
                                  </li>
                                  <li>
                                    <TypographyLimit limit={40} text={visit?.reason || ""} className="get_vaccine" />
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {
                            visit?.note || ""
                          }
                        </Accordion.Body>
                      </Accordion.Item>
                    })
                  }
                </Accordion>
              </div>
            </div>

            {
              selectedVisit?._id
                ?
                <div className=" col-sm-12 col-md-6 col-lg-6">
                  <div className="doctor_visit_rgt">
                    <div className="doctor_visit_card">
                      {/* <div className="header-title">Reaching and Grasping</div> */}

                      <div className="date-time">
                        Doctor Name
                        <br />
                        {selectedVisit?.doctorName}
                      </div>

                      <div className="date-time">
                        Date & Time
                        <br />
                        {dateFormatWithTime(selectedVisit?.createdAt)}
                      </div>

                      <div className="date-time">
                        Reaction(Optional)
                        <br />
                        {selectedVisit?.reason || ""}
                      </div>

                      <div className="image-wraper">
                        {/* <p>image</p> */}
                        <img src={selectedVisit?.image?.length ? selectedVisit?.image : Vaccination_img} alt="Baby wrapped in towel" />
                      </div>

                      <div className="motorskilltracking-note">
                        <p>
                          {
                            selectedVisit?.note || ""
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                :
                null
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorVisit;
